import React from 'react';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';

const Header = ({ onBookDemo }) => {
  return (
    <Navbar expand="lg" className="site-header" sticky="top" bg="white">
      <Container className="site-header__container">
        <Navbar.Brand href="/" aria-label="Lien Logic home" className="site-header__brand">
          <img
            src="/images/logo.svg"
            alt="Lien Logic"
            className="site-header__logo"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="primary-nav" className="site-header__toggler" />

        <Navbar.Collapse id="primary-nav" className="site-header__collapse">
          <Nav className="site-header__nav">
            <Nav.Link href="#product" className="site-header__link">
              Product
            </Nav.Link>
            <Nav.Link href="#how-it-works" className="site-header__link">
              How it Works
            </Nav.Link>
          </Nav>

          <Nav className="site-header__actions">
            <Nav.Link
              as="button"
              type="button"
              className="site-header__cta"
              onClick={onBookDemo}
            >
              Book a Demo
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;
